import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/organization-identity-new'));

export default function (dependencies) {
  const { language } = dependencies;
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    validators: [
      function (state, globalState, config) {
        if (state.error) {
          return language['organization-identity-invalid'];
        }

        return false;
      },
    ],
    config: {
      validators: ['mandatory'],
      behaviour: 'text-input',
    },
  };
}
